import React from "react";
import { classes } from "./tokens";

/**
 * Partner logo strip — text-based plates (no external image dependency).
 * Marquee scroll behaviour on mobile, static grid on desktop.
 */
const partners = [
  { name: "HDFC Bank", color: "#004C8F" },
  { name: "ICICI Bank", color: "#F58220" },
  { name: "Axis Bank", color: "#97144D" },
  { name: "Bajaj Finserv", color: "#0A60AA" },
  { name: "Cars24", color: "#7A28D4" },
  { name: "OLX Autos", color: "#23E5DB" },
  { name: "ICICI Lombard", color: "#F58220" },
  { name: "HDFC Ergo", color: "#004C8F" },
];

const Plate = ({ name, color }) => (
  <div className="shrink-0 px-6 py-4 bg-white rounded-xl border border-slate-200 hover:border-slate-300 hover:shadow-sm transition-all">
    <div className="flex items-center gap-2.5">
      <div
        className="w-2.5 h-2.5 rounded-full shrink-0"
        style={{ backgroundColor: color }}
      />
      <div className="text-sm font-bold text-slate-700 tracking-tight whitespace-nowrap">
        {name}
      </div>
    </div>
  </div>
);

const CarServicePartners = () => (
  <section className="py-14 lg:py-20 bg-white" data-testid="partners-section">
    <div className={classes.container}>
      <div className="text-center mb-8">
        <span className={classes.overline}>Trusted Partners</span>
        <h2 className="text-2xl sm:text-3xl tracking-tight font-extrabold text-slate-900 mt-2">
          The brands that trust Wisedrive's reports
        </h2>
      </div>

      {/* Mobile: scrollable marquee */}
      <div className="lg:hidden flex gap-3 overflow-x-auto pb-2 -mx-5 px-5 scrollbar-hide snap-x">
        {partners.map((p) => (
          <div key={p.name} className="snap-start">
            <Plate {...p} />
          </div>
        ))}
      </div>

      {/* Desktop: centered grid */}
      <div className="hidden lg:flex flex-wrap justify-center gap-4">
        {partners.map((p) => (
          <Plate key={p.name} {...p} />
        ))}
      </div>
    </div>
  </section>
);

export default CarServicePartners;
